import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import AdminTableComponent from 'routes/Admin/components/CommonComponents/AdminTableComponent'
import {
  MODAL_ADMIN_EDIT_LOCKER,
  MODAL_ADMIN_CREATE_LOCKER
} from 'redux/modules/modals'
const clientTransform = value => {
  return value
    ? `${value.customers_last_name} ${value.customers_first_name}`
    : '-'
}
const defaultColumnData = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Nom' },
  {
    id: 'customer',
    numeric: false,
    disablePadding: false,
    label: 'Client',
    transform: clientTransform
  },
  { id: 'available', bool: true, disablePadding: false, label: `Disponible` },
  {
    id: 'expirationDate',
    expiration: true,
    disablePadding: true,
    label: `Date d'expiration`
  }
]
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden',
    paddingLeft: 8,
    paddingRight: 8
  },
  scrollContainer: {
    overflow: 'scroll',
    paddingLeft: 2,
    paddingRight: 2,
    paddingBottom: 4,
    width: 'calc(100%)',
    height: 'calc(100%)'
  }
})
export default withStyles(styles)(
  class LockersComponent extends Component {
    static propTypes = {
      classes: PropTypes.object.isRequired,
      lockers: PropTypes.array.isRequired,
      showModal: PropTypes.func.isRequired
    }
    handleAddLockerClick = () => {
      this.props.showModal(MODAL_ADMIN_CREATE_LOCKER)
    }
    handleEditLockerClick = locker => {
      this.props.showModal(MODAL_ADMIN_EDIT_LOCKER, locker)
    }
    render() {
      const { classes, lockers } = this.props
      return (
        <Grid
          className={classes.container}
          item
          container
          direction="row"
          alignItems="stretch"
          justify="flex-start">
          <Grid className={classes.scrollContainer} item xs={12}>
            <AdminTableComponent
              search={['name', 'customer']}
              title="Casiers"
              selectable={false}
              list={lockers}
              orderBy={'name'}
              columnData={defaultColumnData}
              addButtonAction={this.handleAddLockerClick}
              editButtonAction={this.handleEditLockerClick}
            />
          </Grid>
        </Grid>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Lockers/components/LockersComponent.js